import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const baseSwitch: SxStyle = {
  display: 'flex',
  alignItems: 'center',
};

export const name: SxStyle = {
  flexShrink: 0,
  textTransform: 'capitalize',
};
